/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExperienceProfessionnelleGridDto } from './ExperienceProfessionnelleGridDto';
import {
    ExperienceProfessionnelleGridDtoFromJSON,
    ExperienceProfessionnelleGridDtoFromJSONTyped,
    ExperienceProfessionnelleGridDtoToJSON,
} from './ExperienceProfessionnelleGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ExperienceProfessionnelleGridDtoPaginatedResults
 */
export interface ExperienceProfessionnelleGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ExperienceProfessionnelleGridDto>}
     * @memberof ExperienceProfessionnelleGridDtoPaginatedResults
     */
    results?: Array<ExperienceProfessionnelleGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ExperienceProfessionnelleGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ExperienceProfessionnelleGridDtoPaginatedResults interface.
 */
export function instanceOfExperienceProfessionnelleGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExperienceProfessionnelleGridDtoPaginatedResultsFromJSON(json: any): ExperienceProfessionnelleGridDtoPaginatedResults {
    return ExperienceProfessionnelleGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ExperienceProfessionnelleGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceProfessionnelleGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ExperienceProfessionnelleGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ExperienceProfessionnelleGridDtoPaginatedResultsToJSON(value?: ExperienceProfessionnelleGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ExperienceProfessionnelleGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

